import { Spinner } from '@chakra-ui/react';

export default function StyledSpinner(props) {
	return <Spinner color="intachurch.primary" size="lg" {...props} />;
}
